import React from 'react'

interface AdsFormProps {
  onSuccess: () => void
}

const AdsForm: React.FC<AdsFormProps> = ({ onSuccess }) => {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    // Simulate successful ads creation
    setTimeout(() => {
      console.log('Ads created successfully')
      onSuccess()
    }, 1000)
  }

  return (
    <div>
      <h2>Ads Form</h2>
      <form onSubmit={handleSubmit}>
        <div>Ads form fields go here...</div>
        <button type="submit">Create Ads</button>
      </form>
    </div>
  )
}

export default AdsForm
